module.exports = __webpack_public_path__ + "img/regionalkaufen-berge.4b404965.svg";